export enum RoleType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  DRIVER = 'DRIVER',
  RESPONSIBLE = 'RESPONSIBLE',
  PLAN = 'PLAN',
  PLANNER = 'PLANNER',
  INVOICE = 'INVOICE',
  ACCOUNTANT = 'ACCOUNTANT',
  REPORTS = 'REPORTS',
  REPORTER = 'REPORTER',
}

export interface RoleModel {
  id: number,
  name: string,
  de?: string,
  description?: string,
}

export const AllRoleTypes: string[] = [
  RoleType.ADMINISTRATOR,
  RoleType.DRIVER,
  RoleType.RESPONSIBLE,
  RoleType.PLAN,
  RoleType.PLANNER,
  RoleType.INVOICE,
  RoleType.ACCOUNTANT,
  RoleType.REPORTS,
  RoleType.REPORTER,
]

export interface RoleRedirects {
  role: RoleType
  url: string
}


export const Redirects: RoleRedirects[] = [
  {role: RoleType.ADMINISTRATOR, url: '/admin-home'},
  {role: RoleType.PLAN, url: '/admin-home'},
  {role: RoleType.PLANNER, url: '/admin-home'},
  {role: RoleType.DRIVER, url: '/driver-rides'},
  {role: RoleType.RESPONSIBLE, url: '/admin-responsibilities'},
  {role: RoleType.INVOICE, url: '/'},
  {role: RoleType.ACCOUNTANT, url: '/'},
  {role: RoleType.REPORTS, url: '/'},
  {role: RoleType.REPORTER, url: '/'},
]

export interface GroupModel {
  id: number,
  de: string,
}

export interface UserGroupModel {
  id: number
  de: string,
}

export interface GroupRoleModel {
  userId: number
  roleId: number
  groupId: number
  roleName: string
  roleTitle: string
  groupTitle: string
}
